export const actions = {
  set: 'SET::CURRENT_SITE',
  resetCurrentSite: 'RESET::CURRENT_SITE'
}
export const setCurrentSite = site => ({ type: actions.set, site })
export const getCurrentSite = state => state.currentSite
export default actions



// WEBPACK FOOTER //
// ./src/store/current-site/actions.js